import React, { useState, useEffect } from "react";
import { getPunchCardTransactions } from "apis";
import { container, tableStyle } from "./analytics.styles";
import { Td } from "./commons";

function PunchCards({ activeApp: { id } }) {
  const [transactions, setTransactions] = useState([]);

  const loadTransactions = async () => {
    try {
      const result = await getPunchCardTransactions(id);
      // console.log(result);
      if (Array.isArray(result)) setTransactions(result);
    } catch (e) {
      setTransactions([]);
      console.error(e);
    }
  };

  useEffect(() => {
    loadTransactions();
  }, []);
  return (
    <table className={tableStyle}>
      <tr>
        <th>Punch Card</th>
        <th>Type</th>
        <th>Used By</th>
        <th>Validated By</th>
        <th>Used On</th>
      </tr>
      {transactions &&
        transactions.map((transaction, idx) => {
          const {
            punchcardId,
            punchcardTitle,
            usedBy,
            usedDate,
            firstName,
            lastName,
            adminFirstName,
            adminLastName,
            punchcardAuditType,
          } = transaction;

          const date = new Date(usedDate).toLocaleDateString();
          const time = new Date(usedDate).toLocaleTimeString();
          const joinName = `${adminFirstName || ""} ${adminLastName || ""}`;
          const validatorName = joinName !== " " && joinName;
          const type = () => {
            switch (punchcardAuditType) {
              case 0:
                return "Received Stamp";
                break;
              case 1:
                return "Redeemed Free Reward";
                break;
              default:
                return "---";
                break;
            }
          };

          return (
            <tr key={idx}>
              <Td>{punchcardTitle}</Td>
              <Td>{type()}</Td>
              <Td>{`${firstName} ${lastName}`}</Td>
              <Td>{validatorName}</Td>
              <Td>{`${date} ${time}`}</Td>
            </tr>
          );
        })}
    </table>
  );
}

export default PunchCards;
